<div class="dashboard-card" [ngStyle]="{'background': bgColor}">
    <img [src]="vectorPath" />
    <div class="icon">
        <!-- <img [src]="iconPath" /> -->

        <!-- Can use icon (if available) -->
        <ng-icon [name]="iconName" [color]="iconColor" size="28"></ng-icon>
    </div>
    <div class="title">
        <p class="b1 font-medium">{{ title }}</p>
    </div>
</div>